import { Pie, mixins } from 'vue-chartjs'
const { reactiveData } = mixins
export default {
  extends: Pie,
  mixins: [reactiveData],
  props: ['chartData', 'options'],
  mounted: function () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: function () {
      this._data._chart.destroy()
      this.renderChart(this.chartData, this.options)
    }
  }
}
